module.exports = "https://cdn.dove.it/_next/static/public/assets/google-stars.a36bfc43b289cea8e85e9c73a0224946.png";